import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css'],
  standalone: false,
})
export class BreadcrumbComponent implements OnInit {
  static readonly ROUTE_DATA_BREADCRUMB = 'breadcrumb';

  readonly home: MenuItem = {
    icon: 'pi pi-home',
    routerLink: '/',
    command: () => {
      this.router.navigate(['/']);
    },
  };

  menuItems!: MenuItem[];

  constructor(public router: Router, public activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.menuItems = this.createBreadcrumbs(this.activatedRoute.root, '/', []);
    });
  }

  private createBreadcrumbs(
    route: ActivatedRoute,
    url: string,
    breadcrumbs: MenuItem[]
  ): MenuItem[] {
    const children: ActivatedRoute[] = route.children;
    url = url.replace(/\/$/, '');

    if (children?.length > 0) {
      for (const child of children) {
        const routeURL: string = child.snapshot.url.map((segment) => segment.path).join('/');
        let currentPath: string;
        if (routeURL !== '') {
          currentPath = `${url}/${routeURL}`;
        } else {
          currentPath = url;
        }

        let label = '';
        if (
          'data' in child.snapshot &&
          BreadcrumbComponent.ROUTE_DATA_BREADCRUMB in child.snapshot.data
        ) {
          label = child.snapshot.data[BreadcrumbComponent.ROUTE_DATA_BREADCRUMB];
        }

        if (label?.length > 0) {
          breadcrumbs.push({ label, routerLink: currentPath });
        }
        return this.createBreadcrumbs(child, currentPath, breadcrumbs);
      }
    }
    return breadcrumbs;
  }
}
